import React, { useEffect, useRef } from "react";
import { Animated, View, StyleSheet } from "react-native";

import Colors from "../../../Resources/Color";

const styles = StyleSheet.create({
  activePulseWrap: {
    flexShrink: 0,
    width: 14,
    height: 14,
    alignItems: "center",
    justifyContent: "center",
  },
  activePulseOuter: {
    position: "absolute",
    width: 14,
    height: 14,
    borderRadius: 7,
    backgroundColor: "rgba(238, 240, 241, 0.9)",
    shadowColor: Colors.bubbleColor,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.2,
    shadowRadius: 3,
    elevation: 1,
  },
  activePulseInner: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: Colors.bubbleColor,
  },
});

const ActivePulseIndicator = () => {
  const pulseScale = useRef(new Animated.Value(1)).current;

  useEffect(() => {
    const pulse = Animated.loop(
      Animated.sequence([
        Animated.timing(pulseScale, {
          toValue: 1.2,
          duration: 600,
          useNativeDriver: true,
        }),
        Animated.timing(pulseScale, {
          toValue: 1,
          duration: 600,
          useNativeDriver: true,
        }),
      ])
    );
    pulse.start();
    return () => pulse.stop();
  }, [pulseScale]);

  return (
    <View style={styles.activePulseWrap}>
      <Animated.View
        style={[
          styles.activePulseOuter,
          { transform: [{ scale: pulseScale }] },
        ]}
      />
      <View style={styles.activePulseInner} />
    </View>
  );
};

export default ActivePulseIndicator;
